/**
 * Token Interceptor
 * 設定でONの場合のみ Authorization: Bearer ヘッダーを付与する
 */

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfigService } from '../config';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(AppConfigService);

  if (config.tokenEnabled && config.tokenValue) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${config.tokenValue}`,
      },
    });
    return next(cloned);
  }

  return next(req);
};
